export default "__VITE_ASSET__BCXviH5k__"